var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4"},[_c('content-pack-sections',{attrs:{"item":_vm.item,"is-loading":_vm.isLoading},on:{"update:item":_vm.onUpdateItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }